import {
	// recaptchaConfig,
	mktoRecaptcha
} from './helpers/mkto.js';

/* eslint-disable no-unused-vars, no-undef */
function newsletterForms(mktoId) {
	let formEls = document.querySelectorAll(`[data-mkto-instance="${mktoId}"]`);
	if (!formEls.length) return;
	console.log('Newsletter forms: ' + formEls.length);

	MktoForms2.whenRendered(function(mktoForm) {
		if (mktoForm.getId() !== mktoId) return;
		let formEl = mktoForm.getFormElem()[0],
			vals = {};
		vals.nlleadgenformlocation = formEl.getAttribute('data-mkto-location');
		vals.nlleadgenformweburl = window.location.href;
		mktoForm.addHiddenFields(vals);
		console.log(mktoForm.getValues());

		mktoForm.onSuccess(function(values, followUpUrl) {
			// adapted from https://nation.marketo.com/t5/product-discussions/pulling-field-from-one-form-to-another/m-p/199965/highlight/true#M145610
			let link = document.createElement('a'),
				fields = ['Email'];
			link.href = followUpUrl;

			link.hash = encodeURIComponent(JSON.stringify(values, fields));
			document.location = link;
			return false;
		});
	});
}
/* eslint-enable no-unused-vars, no-undef */

newsletterForms(1640);
mktoRecaptcha(1640);


